module.exports = __webpack_public_path__ + "img/lab-integration.7460f3d6.png";